import { render } from "./ReceiptButton.vue?vue&type=template&id=453ecb6c&scoped=true"
import script from "./ReceiptButton.vue?vue&type=script&lang=js"
export * from "./ReceiptButton.vue?vue&type=script&lang=js"

import "./ReceiptButton.vue?vue&type=style&index=0&id=453ecb6c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-453ecb6c"]])

export default __exports__